export default "__VITE_ASSET__BAg_xzse__"